import { api } from "@/lib/api"
import { sumWorkspaceSeries } from "./workspace-series-total"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AiResolutionsChart() {
	const query = api.analytics.aiResolutionsByWorkspaceChart.useQuery({})
	const total = sumWorkspaceSeries(query.data?.series)
	const perWorkspace = query.data?.perWorkspace

	return (
		<WorkspaceStackedBarChart
			title="Resolutions across customers"
			description="Support agent sessions the agent marked resolved itself, by day and workspace. This count is stricter than the resolution rate, which also counts closed threads no teammate answered. Today is left out, so every bar covers a full day. Per workspace divides resolutions by the workspaces the agent answered a customer for, and leaves out yesterday, which the silence sweep has not closed yet."
			unit="day"
			data={query.data?.series}
			isLoading={query.isLoading}
			height="h-[220px]"
			legend={
				total === null ? undefined : (
					<div className="flex gap-6 text-right">
						{perWorkspace?.current.perWorkspace != null && (
							<div>
								<p className="text-2xl font-semibold tabular-nums text-primary">
									{perWorkspace.current.perWorkspace.toLocaleString("en-US")}
								</p>
								<p className="text-xs text-tertiary">
									per workspace, last {perWorkspace.windowDays} days
									{perWorkspace.previous.perWorkspace != null &&
										` (${perWorkspace.previous.perWorkspace.toLocaleString("en-US")} before)`}
								</p>
							</div>
						)}
						<div>
							<p className="text-2xl font-semibold tabular-nums text-primary">
								{total.toLocaleString("en-US")}
							</p>
							<p className="text-xs text-tertiary">
								resolutions in the last 90 days
							</p>
						</div>
					</div>
				)
			}
		/>
	)
}
